import DynamicForm from '../components/dynamicForm';

const Customer = () => {
  const fields = [
    {
      id: 'name',
      type: 'text',
      placeholder: 'الاسم',
      required: true
    },
    {
      id: 'mobile',
      type: 'phone',
      placeholder: 'رقم الجوال',
      required: true
    },
    {
      id: 'giftType',
      type: 'select',
      placeholder: 'نوع الهدية',
      required: true,
      options: [
        { value: 'women', label: 'نسائي' },
        { value: 'men', label: 'رجالي' }
      ]
    }
  ];
const competitionTerms = {
  title: 'شروط وأحكام المسابقة',
  sections: [
    {
      type: 'list',
      items: [
        'تكون آلية المشاركة في المسابقة من خلال الدخول إلى الرابط المخصص لها وتعبئة البيانات المطلوبة.',
        'تبدأ المشاركة في المسابقة اعتبارًا من تاريخ 22/09/2026م، على أن يبدأ السحب على الجوائز بتاريخ 09/10/2026م ويستمر السحب حتى تاريخ 17/10/2026م.',
        'يتم اختيار الفائزين من بين المشاركين من خلال السحب العشوائي.',
        'يحق لكل فائز الحصول على جائزة واحدة فقط ضمن هذه المسابقة.',
        'يتم تحديد فئة الجائزة (نسائية / رجالية) وفقًا للبيانات المسجلة من قبل المشارك عند الدخول في المسابقة.',
        'لا يمكن استبدال الجوائز بقيمتها النقدية أو استبدالها بجوائز أخرى.',
        'يتم التواصل مع الفائز من خلال بيانات التواصل المسجلة عند المشاركة في المسابقة.',
        'يلتزم الفائز بتزويد زايروس بالبيانات المطلوبة لاستلام الجائزة خلال (24) ساعة من وقت التواصل معه.',
        'في حال تعذر التواصل مع الفائز أو عدم تزويد زايروس بالبيانات المطلوبة خلال المدة المحددة، يحق لزايروس إعادة السحب واختيار فائز آخر.',
        'تعتمد بيانات التواصل وعنوان استلام الجائزة عند تأكيدها من قبل الفائز، ولا يمكن تعديلها بعد ذلك.',
        'يتم تسليم الجائزة للفائز شخصيًا وفقًا للبيانات المسجلة عند المشاركة، ولا يجوز تحويل استحقاق الجائزة إلى شخص آخر.',
        'تعد المشاركة في المسابقة موافقة من المشارك على جميع الشروط والأحكام الخاصة بها والمشار إليها.'
      ]
    },
    {
      title: 'الجوائز المقدمة',
      prizes: [
        {
          title: '🥇 الجائزة الأولى',
          items: [
            'يحصل الفائز على هدية واحدة من منتجات زايروس شهريًا لمدة عام، بإجمالي (12) هدية.'
          ]
        },
        {
          title: '🥈 الجائزة الثانية',
          items: [
            'يحصل الفائز على ساعة ألماس مقدمة من زايروس.'
          ]
        },
        {
          title: '🥉 الجائزة الثالثة',
          items: [
            'قسائم شرائية من زايروس بإجمالي قيمة قدرها (20,000) عشرون ألف ريال سعودي، توزع على (166) فائزًا.',
            'يحصل كل فائز على قسيمة شرائية واحدة، تتراوح قيمتها من (50) ريالًا إلى (250) ريالًا، ويتم تحديد قيمة القسيمة لكل فائز عن طريق السحب العشوائي.',
            'تخصص القسائم الشرائية لشراء منتجات زايروس، وتخضع لشروط وأحكام الاستخدام الخاصة بها.'
          ]
        }
      ]
    }
  ]
};
  return (
    <DynamicForm
      formType="Customer"
      fields={fields}
      banner="/images/cards_winner_banner.webp"
      title="الجوائز تنتظر فائزينها.. سجّل الآن"
      introText=" "
      terms={competitionTerms}
    />
  );
};

export default Customer;